


















import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            filters: [],
            ignoreFilterChanges: false,
        };
    },
    props: {
        headers: Array,
        computedFilters: { required: true },
    },
    watch: {
        computedFilters: {
            handler(newVal) {
                this.filters = newVal;
            },
            deep: true,
            immediate: true,
        },

        filters: {
            handler(newFilters) {
                if (!this.ignoreFilterChanges) this.$emit("filters-changed", newFilters);
                else this.ignoreFilterChanges = false;
            },
            deep: true,
        },
    },
    mounted() {
        this.ignoreFilterChanges = true;
        this.filters = this.computedFilters;
    },
});
